/**
 * MKS-508 — the public company docs (docs/public), read through the backend.
 *
 * The doc text is never part of the frontend bundle: it arrives only through
 * this authenticated API.
 */
import { apiGet } from './client';

export interface CompanyDocSummary {
  slug: string;
  title: string;
}

export interface CompanyDoc extends CompanyDocSummary {
  markdown: string;
}

export function listCompanyDocs(): Promise<CompanyDocSummary[]> {
  return apiGet<{ data: CompanyDocSummary[] }>('/company-docs').then((r) => r.data);
}

export function getCompanyDoc(slug: string): Promise<CompanyDoc> {
  return apiGet<{ data: CompanyDoc }>(`/company-docs/${encodeURIComponent(slug)}`).then(
    (r) => r.data,
  );
}
